/**
 * © 2025 Malvys Exaucé Dessou — ZonePro. Tous droits réservés.
 */
import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import VersionStamp from './VersionStamp';

const Footer = () => {
  const { t } = useLanguage();
  
  return (
    <footer className="w-full py-4 text-center border-t border-border/40 bg-zonepro-surface/50 backdrop-blur-sm">
      <p className="text-xs text-muted-foreground">
        {t('footer.copyright')}
      </p>
      <VersionStamp className="block mt-1 text-[10px] text-muted-foreground/70" testId="version-footer" />
    </footer>
  );
};

export default Footer;
